'use client';

import {useState} from 'react';
import {useRouter} from 'next/navigation';

const HUBSPOT_PORTAL_ID = '44722511';
const HUBSPOT_FORM_GUID = '50c554e4-6400-4793-8f6a-31cd3d757b57';

const Form = () => {
  const router = useRouter();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    const formData = new FormData(e.target);
    
    const fields = [
      {name: 'firstname', value: formData.get('firstname')},
      {name: 'lastname', value: formData.get('lastname')},
      {name: 'email', value: formData.get('email')},
      {name: 'phone', value: formData.get('phone')},
      {name: 'company', value: formData.get('company')},
      {name: 'how_did_you_hear_about_us', value: formData.get('how_did_you_hear_about_us')},
    ];

    const hubspotData = {
      fields: fields.filter(field => field.value),
      context: {
        pageUri: window.location.href,
        pageName: document.title,
      },
    };

    try {
      const response = await fetch(
        `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${HUBSPOT_FORM_GUID}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(hubspotData),
        }
      );

      if (response.ok) {
        e.target.reset();
        router.push('/thanks');
      } else {
        setSubmitMessage('Something went wrong. Please try again.');
      }
    } catch (error) {
      setSubmitMessage('Error submitting form. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className='form'>
      <p className='form-title'>Message our team</p>
      <p className='form-subtitle'>Enter your details in the form and we&apos;ll be in touch shortly.</p>
      <form className='contact-form' onSubmit={handleSubmit}>
        <div className='input-wrapper half-input'>
          <input name='firstname' id='firstname' type='text' maxLength='50' placeholder='Jane' required />
          <label htmlFor='firstname'>First name*</label>
          <span className='input-invalid'>*First name is required</span>
        </div>

        <div className='input-wrapper half-input'>
          <input name='lastname' id='lastname' type='text' maxLength='50' placeholder='Doe' required />
          <label htmlFor='lastname'>Last name*</label>
          <span className='input-invalid'>*Last name is required</span>
        </div>

        <div className='input-wrapper half-input'>
          <input name='email' id='email' type='email' maxLength='70' placeholder='@example' required />
          <label htmlFor='email'>Business email*</label>
          <span className='input-invalid'>*Email is required</span>
        </div>

        <div className='input-wrapper half-input'>
          <input name='phone' id='phone' type='text' maxLength='50' placeholder='+1 ( 493) 678 67 85' required />
          <label htmlFor='phone'>Phone*</label>
          <span className='input-invalid'>*Phone is required</span>
        </div>

        <div className='input-wrapper'>
          <input name='company' id='company' className='company' type='text' maxLength='70' placeholder='Your company name' />
          <label htmlFor='company'>Company</label>
        </div>

        <div className='input-wrapper'>
          <input name='how_did_you_hear_about_us' id='how_did_you_hear_about_us' type='text' maxLength='255' placeholder='How did you hear about us?' />
          <label htmlFor='how_did_you_hear_about_us'>How did you hear about us?</label>
        </div>

        <div className='form-submit'>
          <div className='checkbox-input'>
            <input type='checkbox' className='chb chb-3' id='checkbox' defaultChecked disabled />
            <label htmlFor='checkbox'>You agree to our <a href="/privacy" style={{textDecoration: 'underline'}}>privacy policy</a></label>
            <span className='input-invalid'>*Agree is required</span>
          </div>

          <button type='submit' className='btn-submit btn book-btn' disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Submit'}
            <span className='arrow-wrapper'>
              <span className='arrow'></span>
            </span>
          </button>
        </div>
        
        {submitMessage && <p className='submit-message'>{submitMessage}</p>}
      </form>
    </div>
  );
};

export default Form;

